<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M13 6.25H16.75V10M16.375 6.625L11.2803 11.7197C10.9875 12.0125 10.5125 12.0125 10.2197 11.7197L8.28033 9.78032C7.98743 9.48745 7.51256 9.48745 7.21967 9.78032L3.25 13.75"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />

  </svg>
</template>

<script>
export default {
  name: 'PeriodDiffIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>
